module.exports = __webpack_public_path__ + "static/media/Hashcat-logo.1cb45529.png";